export default {
    medicalScientificDegrees: 'medical Scientific Degrees',
    medicalScientificDegreesTitle: 'Title',
    medicalScientificDegreesStatus: 'Status',
    editMedicalScientificDegrees: 'Edit Medical Scientific Degrees',
    addMedicalScientificDegrees: 'New medical Scientific Degrees',
}